export default "__VITE_ASSET__D1U$Mdsn__"